/**
 * Includes for the payout payment view experience in Admin
 *
 * @type {string[]}
 */
export const PAYOUT__SH_PAYMENT_INCLUDES = [
  'actions',
  'actions.user',
  'application',
  'application.company',
  'fee-structure',
  'user.preferred-payout-account',
  'sh-payment-line-items.application',
  'sh-payment-line-items.project-line-item',
  'sh-payment-transactions',
  'sh-invoice',
];
